<button
  class="w-fit"
  sharedCoreButton
  variant="primary"
  shape="square"
  [disabled]="disabled()"
  (click)="clicked.emit(); $event.stopImmediatePropagation()">
  <shared-core-material-icon [name]="'add'" />
  <ng-content></ng-content>
</button>
